// Legacy components
import './scripts/polyfills';
import marketContentModification from './scripts/marketContentModification';
import linkFeatures from './scripts/linkFeatures';

// Atoms
import inputFields from './atoms/forms/text-field/text-field';
import selectList from './atoms/forms/select/select';

// Molecules
import navigationTags from './molecules/navigation/navigation-tags/navigation-tags';

window.addEventListener('load', () => {
  // Atoms
  inputFields.init();
  selectList.init();

  // Molecules
  navigationTags.init();

  marketContentModification.init();
  linkFeatures.init();
});

marketContentModification.bindEarlyEvents();
